import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { StrategyEx } from "@front/m19-models";
import { CampaignType } from "@front/m19-api-client";
import { StrategyLinkComponent } from "@m19-board/shared/strategy-link/strategy-link.component";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-strategies-info",
  templateUrl: "./strategies-info.component.html",
  styleUrls: ["./strategies-info.component.scss"],
  imports: [StrategyLinkComponent, TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategiesInfoComponent {
  @Input() strategies!: StrategyEx[];
  @Input() campaignType!: CampaignType;

  getStrategies(): StrategyEx[] {
    return this.strategies.filter((x) => x.campaignType == this.campaignType);
  }
}
